<template>
  <div class="order">
    <div class="order-title">
      {{ $t('views.order.title', { id: getOrder.id }) }}
    </div>
    <div
      v-for="(creditOffered, index) in getOrder.credit_offereds"
      :key="index"
      class="order-content"
    >
      <card-info
        :item="creditOffered"
        :business="getBusiness"
      />
      <div class="d-flex flex-column justify-space-between">
        <p class="total-value">
          {{ $t('views.order.total_value',
                {
                  material_type: creditOffered.material_type.toLowerCase(),
                  total_value: formatMoney(creditOffered.total_value_with_aditional)
                })
          }}
        </p>

        <rectoplus-button
          v-if="isRecEntity && orderIsPaid"
          class="reoffer-button"
          :text="$t('views.order.reoffer')"
          @click="openReofferModal(creditOffered)"
        />

        <p
          v-if="orderIsPending"
          class="font-weight-black"
        >
          <a
            :href="paymentLink"
            target="_blank"
          >
            {{ $t('views.order.payment_link') }}
          </a>
        </p>
      </div>
    </div>
    <order-certificate-summary
      v-if="hasCertificate"
      :order="getOrder"
      class="certify-info"
    />
    <create-reoffer-modal
      v-if="!editReoffer && reofferModal"
      :credit-offered="currentCreditOffered"
      @close="closeModal"
      @confirm="reofferCredit"
    />

    <edit-reoffer-modal
      v-if="editReoffer && reofferModal"
      :credit-offered="currentCreditOffered"
      :reoffers="getReoffers"
      @close="closeModal"
      @confirm="reofferCredit"
    />
  </div>
</template>
<script>
import formatMoney from '@/mixins/formatMoney';
import CardInfo from '@/components/cards/offered/CardInfo.vue';
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';
import EditReofferModal from '@/components/modals/EditReofferModal.vue';
import CreateReofferModal from '@/components/modals/CreateReofferModal.vue';
import OrderCertificateSummary from '@/components/orders/OrderCertificateSummary.vue';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Order',

  components: {
    CardInfo,
    OrderCertificateSummary,
    RectoplusButton,
    CreateReofferModal,
    EditReofferModal,
  },
  mixins: [formatMoney],
  data() {
    return {
      reofferModal: false,
      currentCreditOffered: null,
      editReoffer: false,
    };
  },

  computed: {
    ...mapGetters([
      'getOrder',
      'getBusiness',
      'orderIsPending',
      'orderIsPaid',
      'getReofferWithSuccess',
      'getNfesToReoffer',
      'getReoffers',
    ]),

    paymentLink() {
      return this.getOrder?.payment?.link_to_payment;
    },

    hasCertificate() {
      return !!this.getOrder?.certify?.url;
    },

    isRecEntity() {
      return this.getBusiness.entity_flag;
    },
  },
  mounted() {
    this.showOrder({ business_id: this.getBusiness.id, id: this.$route.params.id });
  },
  methods: {
    ...mapActions(['showOrder', 'createReoffer', 'fetchNfesToReoffer', 'fetchReoffers']),

    reofferCredit(offersPayload) {
      this.createReoffer({
        business_id: this.getBusiness.id,
        credit_offered_id: this.currentCreditOffered.id,
        offers_payload: offersPayload,
      });
    },

    openReofferModal(creditOffered) {
      this.currentCreditOffered = creditOffered;

      if (creditOffered.reoffered) {
        this.fetchReoffers({
          business_id: this.getBusiness.id,
          credit_offered_id: creditOffered.id,
        });
        this.editReoffer = true;
      } else {
        this.fetchNfesToReoffer(creditOffered.id);
        this.editReoffer = false;
      }
    },

    closeModal() {
      this.reofferModal = false;
      this.currentCreditOffered = null;
      this.editReoffer = false;
    },
  },
  watch: {
    getNfesToReoffer: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.reofferModal = true;
        }
      },
    },
    getReoffers: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.reofferModal = true;
        }
      },
    },
    getReofferWithSuccess: {
      handler(newVal) {
        if (newVal) {
          this.closeModal();
          this.$router.push({ name: 'my-offereds' });
        }
      },
    },
  },

};
</script>
<style lang="scss" scoped>
  .order {
    background-color: $app_background;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 2em 2em 2em 16em;

    .order-title {
      font-size: 1.5em;
      font-weight: bold;
      margin-bottom: 40px;
      text-align: center;
    }

    .reoffer-button {
      width: 100%;
      height: 50px;
    }

    .order-content{
      margin-bottom: 30px;
      background-color: $color_light;
      padding: 30px;
      box-shadow: $box_shadow_my_offereds;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;

      .total-value {
        font-size: 1em;
        font-weight: bold;
        display: flex;
        align-items: flex-end;
      }
    }

    .certify-info {
      margin-top: 10px;
    }
  }
</style>
